import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDrink: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="drink, cup, straw, mug"><path d="M17.25 22.25H6.75L6.07258 11.75L5.75 6.75H18.25L17.9274 11.75L17.25 22.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.07227 11.75H17.9271" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 6.75V2.75L16.25 1.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDrink;
